<template lang="pug">
  .module__main
    .module__title Информация сервера
    .module-content__container
      .server-info__container
        .server-info-title__container
          .title Список процессов
        .table__container
          .table-list__container
            el-table(
              v-loading="isScriptsLoading"
              :data="formattedScripts"
              style="width: 100%; font-size: 12px"
            )
              el-table-column(prop="name" label="Имя процесса" width="200")
              el-table-column(prop="status" label="Статус" width="200")
              el-table-column(prop="uptime" label="Время запуска" width="200")
              el-table-column(prop="cpu" label="Загрузка ЦП (%)" width="200")
              el-table-column(prop="mem" label="Загрузка RAM (Мб)" width="200")
              el-table-column(label="Действия" width="200")
                template(slot-scope="scope")
                  .scripts-buttons__container(v-if="scope.row.isActionsAvailable")
                    el-button(
                      icon="el-icon-refresh-left"
                      type="success"
                      size="mini"
                      circle
                      title="Перезапустить"
                      @click="startRestartScript(scope.row.id, scope.row.name)"
                      )
                    el-button(
                      icon="el-icon-video-pause"
                      type="danger"
                      size="mini"
                      circle
                      title="Остановить"
                      @click="startStopScript(scope.row.id, scope.row.name)"
                      )
      .server-info__container
        .server-info-title__container
          .title Список Tor-нод
          el-button(type="warning" size="mini" @click="startRestartTorService()") Перезапустить Tor-сервис
        .table__container
          .table-list__container
            el-table(
              v-loading="isNodesLoading"
              :data="formattedNodes"
              style="width: 100%; font-size: 12px"
            )
              el-table-column(prop="description" label="Описание" width="200")
              el-table-column(prop="port" label="Занятый порт" width="200")
              el-table-column(prop="accessibility" label="Доступность (%)" width="200")
              el-table-column(prop="latency" label="Среднее время запроса (мс)" width="300")
              el-table-column(prop="lastCheckTime" label="Время последней проверки" width="300")
              el-table-column(label="Действия" width="200")
                template(slot-scope="scope")
                  .scripts-buttons__container
                    el-button(
                      icon="el-icon-refresh"
                      type="success"
                      size="mini"
                      circle
                      title="Перестроить цепочку"
                      alt="Перезапустить"
                      @click="startRestartTorNode(scope.row._id)"
                      )
</template>
<script>
import {mapActions, mapGetters} from 'vuex';
import {
  LOAD_SCRIPTS_LIST,
  LOAD_TOR_NODES_LIST,
  RESTART_SCRIPT,
  RESTART_TOR_NODE,
  RESTART_TOR_SERVICE, STOP_SCRIPT
} from "@/store/const/server";
import instruments from "@/mixins/instruments";

export default {
  name: "ServerInfo",
  mixins: [
    instruments,
  ],
  data() {
    return {
      intervalHandle: null,
    }
  },
  async mounted() {
    await this.loadServerInfo();
    this.startInterval();
  },
  beforeDestroy() {
    clearInterval(this.intervalHandle);
  },
  computed: {
    ...mapGetters([
      'loading',
      'error',
    ]),
    ...mapGetters('server', {
      torNodes: 'torNodes',
      scripts: 'scripts',
    }),
    isNodesLoading() {
      return this.loading(LOAD_TOR_NODES_LIST) === 'loading';
    },
    isScriptsLoading() {
      return this.loading(LOAD_SCRIPTS_LIST) === 'loading';
    },
    formattedScripts() {
      const statusLocales = {
        online: 'Запущен',
        stopping: 'В процессе остановки',
        stopped: 'Остановлен',
        launching: 'В процессе запуска',
        errored: 'Ошибка при запуске',
        'waiting restart': 'Ожидает перезапуска',
        'one-launch-status': 'Однократный запуск'
      };
      return this.scripts.map((current) => {
        return {
          ...current,
          status: statusLocales[current.status] || current.status,
        }
      });
    },
    formattedNodes() {
      return this.torNodes.map((current) => {
        return {
          ...current,
          lastCheckTime: new Date(current.lastCheckTime).toLocaleString(),
        }
      });
    },
  },
  methods: {
    ...mapActions('server', {
      loadTorNodesList: LOAD_TOR_NODES_LIST,
      loadScriptsList: LOAD_SCRIPTS_LIST,
      restartScript: RESTART_SCRIPT,
      restartTorNode: RESTART_TOR_NODE,
      restartTorService: RESTART_TOR_SERVICE,
      stopScript: STOP_SCRIPT,
    }),
    async loadServerInfo() {
      if (!this.isNodesLoading) {
        await this.loadScriptsList();
      }
      if (!this.isScriptsLoading) {
        await this.loadTorNodesList();
      }
    },
    startInterval(){
      this.intervalHandle = setInterval(() => this.loadServerInfo(), 10000);
    },
    async startRestartScript(id, name) {
      this.$confirm(`Вы уверены, что хотите перезапустить процесс ${name}?`, 'Подтверждение').then(async () => {
        const request = await this.restartScript(id);
        this.handleRequestAndNotify({
          request,
          successMessage: 'Процесс успешно перезапущен',
          errorMessage: 'Ошибка перезапуска процесса',
        })
      }).catch(() => {
        this.$message.info('Перезапуск процесса отменен');
      })
    },
    async startStopScript(id, name) {
      this.$confirm(`Вы уверены, что хотите остановить процесс ${name}?`, 'Подтверждение').then(async () => {
        const request = await this.stopScript(id);
        this.handleRequestAndNotify({
          request,
          successMessage: 'Процесс успешно остановлен',
          errorMessage: 'Ошибка остановки процесса',
        })
      }).catch(() => {
        this.$message.info('Остановка процесса отменена');
      })
    },
    async startRestartTorNode(id) {
      this.$confirm(`Вы уверены, что хотите сгенерировать новую цепочку для Tor-ноды?`, 'Подтверждение').then(async () => {
        const request = await this.restartTorNode(id);
        this.handleRequestAndNotify({
          request,
          successMessage: 'Новая цепочка сгенерирована',
          errorMessage: 'Ошибка генерации новой цепочки',
        })
      }).catch(() => {
        this.$message.info('Генерация новой цепочки отменена');
      })
    },
    async startRestartTorService() {
      this.$confirm(`Вы уверены, что хотите перезапустить Tor-сервис?`, 'Подтверждение').then(async () => {
        const request = await this.restartTorService();
        this.handleRequestAndNotify({
          request,
          successMessage: 'Сервис успешно перезапущен',
          errorMessage: 'Ошибка перезапуска сервиса',
        })
      }).catch(() => {
        this.$message.info('Перезапуск сервиса отменен');
      })
    },
  }
}
</script>
<style>
.server-info__container {
    border: 1px solid #9f9f9f;
    background-color: #edecec;
    margin-bottom: 5px;
    max-height: 400px;
    overflow-y: scroll;
}

.server-info-title__container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 5px auto;
}

.server-info-title__container .title {
    margin-bottom: 0;
    margin-right: 5px;
}
</style>
